<template>
  <div class="ui-grid va-row">
    <div class="flex md12 xs12">
      <vuestic-widget :headerText="$t('my.profile')">
        <div class="flex-center bottomMargin20">
          <button @click="downloadData()" class="btn btn-primary btn-with-icon">
            <div class="btn-with-icon-content">
              <i class="ion-ios-arrow-down ion"></i>
              {{'profile.downloadData' | translate}}
            </div>
          </button>
        </div>
        <div class="flex-center bottomMargin20">
          <button @click="openPersonalData()" class="btn btn-primary btn-with-icon">
            <div class="btn-with-icon-content">
              <i class="ion-md-checkmark ion"></i>
              {{'profile.personalData' | translate}}
            </div>
          </button>
        </div>
        <div class="flex-center bottomMargin20">
          <button @click="deleteAllData()" class="btn btn-primary btn-with-icon">
            <div class="btn-with-icon-content">
              <i class="ion-md-close ion"></i>
              {{'profile.deleteAllData' | translate}}
            </div>
          </button>
        </div>
      </vuestic-widget>
    </div>
    <document-preview :show.sync="showDeleteConfirm" v-bind:large="true" ref="documentPreview"
                      :okText="'modal.confirm' | translate"
                      :cancelText="'modal.cancel' | translate">
      <div>
        {{'profile.deleteDataAlert' | translate}}

      </div>
    </document-preview>
  </div>
</template>

<script>
// import Vue from 'vue'
import DocumentPreview from 'components/DocumentPreview'
import { profileApi } from '../../services/api/profileApi'

// Vue.component('document-preview', DocumentPreview)

export default {
  name: 'grid',

  components: {
    DocumentPreview
  },

  data () {
    return {
      showDeleteConfirm: true,
    }
  },
  methods: {
    showDocumentPreview () {
      this.$refs.documentPreview.open()
    },

    downloadData () {
    },

    openPersonalData () {
      this.$router.push({ name: 'personalData' })
    },

    deleteAllData () {
      this.$refs.documentPreview.open()
    },

    ok () {
      profileApi.deleteData()
    },

    cancel () {
      this.$refs.documentPreview.close()
    }
  }
}
</script>

<style lang="scss">
  .ui-grid {
    ._green-rectangle {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      min-height: 3rem;
      color: $white;
      background-color: $brand-primary;
      border-radius: 0.5rem;
    }
  }

</style>
